import RecipeIngredients, { RecipeIngredientsProps } from "./RecipeIngredients";

export { RecipeIngredients, RecipeIngredientsProps };

export default RecipeIngredients;
